import Close from '@mui/icons-material/Close'
import { IconButton, Stack, styled, Typography, useTheme } from '@mui/material'
import type { Relative } from '../api/api'

interface RelativeRowProps {
  relative: Relative
  onRemove: (relative: Relative) => void
  connections: number | undefined
}

export const RelativeRow = ({ relative, onRemove, connections }: RelativeRowProps) => {
  const { palette } = useTheme()

  return (
    <RelativeRowContainer>
      <Stack
        direction="row"
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Stack
          sx={{
            gap: 0.5,
          }}
        >
          <Typography data-testid="template-external-name" variant="p1Medium">
            {relative.externalName}
          </Typography>
          <Typography data-testid="template-name" variant="subtitle1" sx={{ color: palette.text.secondary }}>
            {relative.name}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Typography variant="p3Medium">{connections ?? 'Unknown'} Customers</Typography>
          <IconButton onClick={() => onRemove(relative)} aria-label="remove relative">
            <Close />
          </IconButton>
        </Stack>
      </Stack>
    </RelativeRowContainer>
  )
}

const RelativeRowContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: theme.palette.divider,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
}))
